module.exports = __webpack_public_path__ + "img/logo-horizontal-azul.061cfd6c.png";